import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Route değişiminde sayfayı en üste kaydırır. React Router default davranışı,
 * yeni rotaya geçişte scroll pozisyonunu korumak; bu liste → detay
 * navigasyonlarında "ortadan açılan sayfa" hatasına yol açıyor.
 *
 * İki edge case'i bilinçli olarak korur:
 *  - <code>POP</code> navigasyonu (tarayıcının ileri/geri butonları): browser
 *    scroll restoration'ı devreye girsin diye scroll'a dokunmaz, böylece
 *    kullanıcı önceki konumuna geri döner.
 *  - URL'de <code>#anchor</code> varsa: tarayıcının native anchor scroll'una
 *    bırakır (örn. blog yazılarındaki İçindekiler bağlantıları).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (hash) return;
    if (navigationType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, navigationType]);

  return null;
}
